export const generatedScenarioDecisionAuditLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-scenario-decision-audit-ledger",
  "operatingRule": "Scenario decision audits convert rankings into explicit flip conditions, assumption sensitivities, validation protocols, and proof burdens for buyer/reviewer diligence.",
  "auditCount": 6,
  "commercialUseAllowed": false,
  "leaderScenarioId": "moon-first",
  "leaderAuditHash": "sha256-58f389a760819fb7a49ad63b1236975d8ed0335cd3249402930af19e25751e7d",
  "evidenceHashes": {
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
    "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
    "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
    "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
    "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
    "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
    "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
  },
  "topCrossoverQuestions": [
    {
      "scenarioId": "moon-first",
      "rank": 1,
      "decisionLane": "lane-2-conditional-diligence",
      "flipKind": "leader-loss-threshold",
      "requiredDelta": 1.43,
      "blockerCount": 18
    },
    {
      "scenarioId": "hybrid",
      "rank": 2,
      "decisionLane": "lane-3-watchlist",
      "flipKind": "challenger-crossover-threshold",
      "requiredDelta": 1.43,
      "blockerCount": 20
    },
    {
      "scenarioId": "asteroid-first",
      "rank": 3,
      "decisionLane": "lane-4-research-backlog",
      "flipKind": "challenger-crossover-threshold",
      "requiredDelta": 15.75,
      "blockerCount": 18
    },
    {
      "scenarioId": "mercury-orbit",
      "rank": 4,
      "decisionLane": "lane-4-research-backlog",
      "flipKind": "challenger-crossover-threshold",
      "requiredDelta": 24.17,
      "blockerCount": 24
    }
  ],
  "audits": [
    {
      "id": "audit-moon-first",
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "auditState": "decision-support-only",
      "commercialUseAllowed": false,
      "rank": 1,
      "decisionLane": "lane-2-conditional-diligence",
      "decisionReadinessScore": 62.91,
      "deterministicUtility": 67.12,
      "explanation": {
        "summary": "Fastest learning loop and lowest communications burden.",
        "topBenefitDrivers": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 76,
            "weight": 1,
            "weightedValue": 76
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 74,
            "weight": 1,
            "weightedValue": 74
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 70,
            "weight": 1,
            "weightedValue": 70
          }
        ],
        "topRiskDrivers": [
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 48,
            "weight": 0.9,
            "weightedValue": 43.2
          },
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 42,
            "weight": 1,
            "weightedValue": 42
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 38,
            "weight": 0.8,
            "weightedValue": 30.4
          }
        ],
        "uncertainty": {
          "iterations": 128,
          "utilityP10": 65.53,
          "utilityMedian": 67.34,
          "utilityP90": 68.89,
          "downsideSpread": 1.81,
          "seed": "moon-first-decision-ledger"
        },
        "economics": {
          "businessReadinessMedian": 76.65,
          "underfundedProbabilityPercent": 0,
          "medianCapitalGapBn": 0,
          "economicsPromotionAllowed": false
        },
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "flipCondition": {
        "kind": "leader-loss-threshold",
        "comparisonScenarioId": "hybrid",
        "comparisonScenarioName": "Hybrid Moon -> Asteroid -> Mercury",
        "utilityGap": 1.43,
        "condition": "The current leader stops winning if its risk/uncertainty burden rises or the next scenario improves by more than the utility gap.",
        "requiredDelta": 1.43
      },
      "sensitiveAssumptions": [
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "utilityDelta": 0.44,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "utilityDelta": 0.2,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "utilityDelta": -0.11,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "utilityDelta": -0.08,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        }
      ],
      "validationProtocolRefs": [
        {
          "protocolId": "protocol-economics-frontier",
          "domain": "economics-optimization",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-968c81718149bfce122f8d6fcbb398bb108720d40fbb38a547b8e07550a65ab3",
          "blockerCount": 7
        },
        {
          "protocolId": "protocol-evidence-provenance",
          "domain": "evidence-and-provenance",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-793627be3059f343ee2f7aa291d7fd819c4387d24788774051f5d6182e65acdb",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-research-package-release",
          "domain": "business-research-workflow",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-329dbe9a04571b57a50023b9046a8754ab339e37348e1877da9e08d025143864",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-trajectory-logistics",
          "domain": "trajectory-logistics",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-eb25f5788db6b754dccd4f4bed46d978b0ecb33912b50897f221139c3a39c741",
          "blockerCount": 7
        }
      ],
      "proofBurden": {
        "blockerCount": 18,
        "criticalNextProofs": [
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "Asteroid/resource candidates are not promoted for resource claims.",
          "Claim claim-helium3: blocked-for-commercial-proof",
          "Claim claim-mercury-core: blocked-for-commercial-proof",
          "Claim claim-spf-separation: blocked-for-commercial-proof"
        ],
        "sourcePromotionState": "source-promotion-ready-for-review",
        "sidecarPromotionState": "partial-runtime-promotion-contract-gaps",
        "modelValidationCommercialUseAllowed": false
      },
      "customerDiligenceQuestions": [
        "What evidence would reduce the Moon-first Bootstrap utility gap or preserve its current rank?",
        "Which assumptions are doing the most work in the ranking?",
        "Which source payloads and runtime sidecars must promote before this can become commercial proof?",
        "Would the conclusion change if launch cost, feedstock confidence, thermal burden, or comms/autonomy assumptions move conservatively?"
      ],
      "evidenceHashes": {
        "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c",
        "traceHash": "sha256-4c9d51ef9294289600bc39fd2b99a03df6edf38557eb137e1a48a9bf1b0d3110",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
      },
      "evidenceBoundary": "Decision audits explain why rankings move and what proof is missing. They are not mission-design validation, investment advice, or verified resource evidence.",
      "auditHash": "sha256-58f389a760819fb7a49ad63b1236975d8ed0335cd3249402930af19e25751e7d"
    },
    {
      "id": "audit-hybrid",
      "scenarioId": "hybrid",
      "name": "Hybrid Moon -> Asteroid -> Mercury",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "auditState": "decision-support-only",
      "commercialUseAllowed": false,
      "rank": 2,
      "decisionLane": "lane-3-watchlist",
      "decisionReadinessScore": 59.78,
      "deterministicUtility": 65.69,
      "explanation": {
        "summary": "Bootstrap close, screen feedstock, then scale toward Mercury energy advantage.",
        "topBenefitDrivers": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 92,
            "weight": 1,
            "weightedValue": 92
          },
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 82,
            "weight": 1,
            "weightedValue": 82
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 82,
            "weight": 1,
            "weightedValue": 82
          }
        ],
        "topRiskDrivers": [
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 55,
            "weight": 1,
            "weightedValue": 55
          },
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 46,
            "weight": 1,
            "weightedValue": 46
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 45,
            "weight": 0.9,
            "weightedValue": 40.5
          }
        ],
        "uncertainty": {
          "iterations": 128,
          "utilityP10": 63.58,
          "utilityMedian": 65.8,
          "utilityP90": 67.74,
          "downsideSpread": 2.22,
          "seed": "hybrid-decision-ledger"
        },
        "economics": {
          "businessReadinessMedian": 72.59,
          "underfundedProbabilityPercent": 0.39,
          "medianCapitalGapBn": 0,
          "economicsPromotionAllowed": false
        },
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "flipCondition": {
        "kind": "challenger-crossover-threshold",
        "comparisonScenarioId": "moon-first",
        "comparisonScenarioName": "Moon-first Bootstrap",
        "utilityGap": 1.43,
        "condition": "This scenario becomes the deterministic leader only if its benefits improve or risks fall by more than the gap to the current leader.",
        "requiredDelta": 1.43
      },
      "sensitiveAssumptions": [
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "utilityDelta": -0.86,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "utilityDelta": -0.21,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "utilityDelta": 0.16,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "utilityDelta": -0.07,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        }
      ],
      "validationProtocolRefs": [
        {
          "protocolId": "protocol-economics-frontier",
          "domain": "economics-optimization",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-968c81718149bfce122f8d6fcbb398bb108720d40fbb38a547b8e07550a65ab3",
          "blockerCount": 7
        },
        {
          "protocolId": "protocol-evidence-provenance",
          "domain": "evidence-and-provenance",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-793627be3059f343ee2f7aa291d7fd819c4387d24788774051f5d6182e65acdb",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-research-package-release",
          "domain": "business-research-workflow",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-329dbe9a04571b57a50023b9046a8754ab339e37348e1877da9e08d025143864",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-trajectory-logistics",
          "domain": "trajectory-logistics",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-eb25f5788db6b754dccd4f4bed46d978b0ecb33912b50897f221139c3a39c741",
          "blockerCount": 7
        }
      ],
      "proofBurden": {
        "blockerCount": 20,
        "criticalNextProofs": [
          "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "Asteroid/resource candidates are not promoted for resource claims.",
          "Claim claim-helium3: blocked-for-commercial-proof"
        ],
        "sourcePromotionState": "source-promotion-ready-for-review",
        "sidecarPromotionState": "partial-runtime-promotion-contract-gaps",
        "modelValidationCommercialUseAllowed": false
      },
      "customerDiligenceQuestions": [
        "What evidence would reduce the Hybrid Moon -> Asteroid -> Mercury utility gap or preserve its current rank?",
        "Which assumptions are doing the most work in the ranking?",
        "Which source payloads and runtime sidecars must promote before this can become commercial proof?",
        "Would the conclusion change if launch cost, feedstock confidence, thermal burden, or comms/autonomy assumptions move conservatively?"
      ],
      "evidenceHashes": {
        "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803",
        "traceHash": "sha256-d733f88bb38e404138d4ac8f6cca29c216f96ef4cfab8d1feb018406ef47b92d",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
      },
      "evidenceBoundary": "Decision audits explain why rankings move and what proof is missing. They are not mission-design validation, investment advice, or verified resource evidence.",
      "auditHash": "sha256-33d847d44aefa2e50026b1ae3d51c01ef182d9bcf6a78459baa92a70bfee5f67"
    },
    {
      "id": "audit-asteroid-first",
      "scenarioId": "asteroid-first",
      "name": "Asteroid Feedstock-first",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "auditState": "decision-support-only",
      "commercialUseAllowed": false,
      "rank": 3,
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.63,
      "deterministicUtility": 51.37,
      "explanation": {
        "summary": "Potential materials bank, but composition and operations are object-specific.",
        "topBenefitDrivers": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 84,
            "weight": 1,
            "weightedValue": 84
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 75,
            "weight": 1,
            "weightedValue": 75
          },
          {
            "kind": "benefit",
            "criterion": "vacuum",
            "rawScore": 85,
            "weight": 0.75,
            "weightedValue": 63.75
          }
        ],
        "topRiskDrivers": [
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 72,
            "weight": 1,
            "weightedValue": 72
          },
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 58,
            "weight": 1,
            "weightedValue": 58
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 55,
            "weight": 0.8,
            "weightedValue": 44
          }
        ],
        "uncertainty": {
          "iterations": 128,
          "utilityP10": 48.51,
          "utilityMedian": 51.07,
          "utilityP90": 54.39,
          "downsideSpread": 2.55,
          "seed": "asteroid-first-decision-ledger"
        },
        "economics": {
          "businessReadinessMedian": 59.76,
          "underfundedProbabilityPercent": 2.73,
          "medianCapitalGapBn": 0,
          "economicsPromotionAllowed": false
        },
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "flipCondition": {
        "kind": "challenger-crossover-threshold",
        "comparisonScenarioId": "moon-first",
        "comparisonScenarioName": "Moon-first Bootstrap",
        "utilityGap": 15.75,
        "condition": "This scenario becomes the deterministic leader only if its benefits improve or risks fall by more than the gap to the current leader.",
        "requiredDelta": 15.75
      },
      "sensitiveAssumptions": [
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "utilityDelta": -1.68,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "utilityDelta": -0.46,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "utilityDelta": -0.39,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "utilityDelta": -0.09,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        }
      ],
      "validationProtocolRefs": [
        {
          "protocolId": "protocol-evidence-provenance",
          "domain": "evidence-and-provenance",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-793627be3059f343ee2f7aa291d7fd819c4387d24788774051f5d6182e65acdb",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-research-package-release",
          "domain": "business-research-workflow",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-329dbe9a04571b57a50023b9046a8754ab339e37348e1877da9e08d025143864",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-small-body-feedstock",
          "domain": "small-body-feedstock",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-e2a6133eb3835d8532f97fc3040426061582bca11eda0ee036e668f84c731224",
          "blockerCount": 5
        },
        {
          "protocolId": "protocol-trajectory-logistics",
          "domain": "trajectory-logistics",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-eb25f5788db6b754dccd4f4bed46d978b0ecb33912b50897f221139c3a39c741",
          "blockerCount": 7
        }
      ],
      "proofBurden": {
        "blockerCount": 18,
        "criticalNextProofs": [
          "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for asteroid-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "tudat-transfer-v1 runtime evidence missing for asteroid-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "Candidate-specific SBDB/CAD/taxonomy/spectra evidence required before resource promotion.",
          "Asteroid/resource candidates are not promoted for resource claims."
        ],
        "sourcePromotionState": "source-promotion-ready-for-review",
        "sidecarPromotionState": "partial-runtime-promotion-contract-gaps",
        "modelValidationCommercialUseAllowed": false
      },
      "customerDiligenceQuestions": [
        "What evidence would reduce the Asteroid Feedstock-first utility gap or preserve its current rank?",
        "Which assumptions are doing the most work in the ranking?",
        "Which source payloads and runtime sidecars must promote before this can become commercial proof?",
        "Would the conclusion change if launch cost, feedstock confidence, thermal burden, or comms/autonomy assumptions move conservatively?"
      ],
      "evidenceHashes": {
        "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051",
        "traceHash": "sha256-d619bbef18fc804057f0cf68a6279068db56356135bf425e70958c3f1b2b904b",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
      },
      "evidenceBoundary": "Decision audits explain why rankings move and what proof is missing. They are not mission-design validation, investment advice, or verified resource evidence.",
      "auditHash": "sha256-ea59ca9e591fd871070d52152e85b96af71e07a355fe4a89ca7f3977d21476fa"
    },
    {
      "id": "audit-mercury-orbit",
      "scenarioId": "mercury-orbit",
      "name": "Mercury Orbit-first",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "auditState": "decision-support-only",
      "commercialUseAllowed": false,
      "rank": 4,
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 44.15,
      "deterministicUtility": 42.95,
      "explanation": {
        "summary": "Maximum long-term energy/vacuum upside, high logistics and autonomy burden.",
        "topBenefitDrivers": [
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 97,
            "weight": 1,
            "weightedValue": 97
          },
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 86,
            "weight": 1,
            "weightedValue": 86
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 84,
            "weight": 1,
            "weightedValue": 84
          }
        ],
        "topRiskDrivers": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 86,
            "weight": 1,
            "weightedValue": 86
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 82,
            "weight": 0.9,
            "weightedValue": 73.8
          },
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 70,
            "weight": 1,
            "weightedValue": 70
          }
        ],
        "uncertainty": {
          "iterations": 128,
          "utilityP10": 38.9,
          "utilityMedian": 42.78,
          "utilityP90": 46.63,
          "downsideSpread": 3.87,
          "seed": "mercury-orbit-decision-ledger"
        },
        "economics": {
          "businessReadinessMedian": 55.33,
          "underfundedProbabilityPercent": 10.94,
          "medianCapitalGapBn": 0,
          "economicsPromotionAllowed": false
        },
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "flipCondition": {
        "kind": "challenger-crossover-threshold",
        "comparisonScenarioId": "moon-first",
        "comparisonScenarioName": "Moon-first Bootstrap",
        "utilityGap": 24.17,
        "condition": "This scenario becomes the deterministic leader only if its benefits improve or risks fall by more than the gap to the current leader.",
        "requiredDelta": 24.17
      },
      "sensitiveAssumptions": [
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "utilityDelta": -0.82,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "utilityDelta": -0.67,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "utilityDelta": -0.28,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "utilityDelta": -0.04,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        }
      ],
      "validationProtocolRefs": [
        {
          "protocolId": "protocol-comms-autonomy",
          "domain": "comms-autonomy",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-aec24f46a6b01243742cd86a6cc49be5b6d626317a0031ecf114d1dd4d8aa5a2",
          "blockerCount": 3
        },
        {
          "protocolId": "protocol-ephemeris-event-windows",
          "domain": "ephemeris-event-windows",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-4aef6e4c4fd115f5dd086dfa3c2a9895f3cc5853cdce2e9b7380c410f5a986d7",
          "blockerCount": 1
        },
        {
          "protocolId": "protocol-evidence-provenance",
          "domain": "evidence-and-provenance",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-793627be3059f343ee2f7aa291d7fd819c4387d24788774051f5d6182e65acdb",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-materials-process",
          "domain": "materials-process",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-95c50ec7fea3f2e2d7d68a00e3f8f7fd7c325f752f4ce78961e69432ee5118db",
          "blockerCount": 9
        },
        {
          "protocolId": "protocol-research-package-release",
          "domain": "business-research-workflow",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-329dbe9a04571b57a50023b9046a8754ab339e37348e1877da9e08d025143864",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-trajectory-logistics",
          "domain": "trajectory-logistics",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-eb25f5788db6b754dccd4f4bed46d978b0ecb33912b50897f221139c3a39c741",
          "blockerCount": 7
        }
      ],
      "proofBurden": {
        "blockerCount": 24,
        "criticalNextProofs": [
          "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for mercury-orbit: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for mercury-orbit: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "tudat-transfer-v1 runtime evidence missing for mercury-orbit: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts.",
          "Asteroid/resource candidates are not promoted for resource claims."
        ],
        "sourcePromotionState": "source-promotion-ready-for-review",
        "sidecarPromotionState": "partial-runtime-promotion-contract-gaps",
        "modelValidationCommercialUseAllowed": false
      },
      "customerDiligenceQuestions": [
        "What evidence would reduce the Mercury Orbit-first utility gap or preserve its current rank?",
        "Which assumptions are doing the most work in the ranking?",
        "Which source payloads and runtime sidecars must promote before this can become commercial proof?",
        "Would the conclusion change if launch cost, feedstock confidence, thermal burden, or comms/autonomy assumptions move conservatively?"
      ],
      "evidenceHashes": {
        "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4",
        "traceHash": "sha256-347c3c0291493190d1eaba179b7e37c09366c6c992e8e7a322640eee5bd05757",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
      },
      "evidenceBoundary": "Decision audits explain why rankings move and what proof is missing. They are not mission-design validation, investment advice, or verified resource evidence.",
      "auditHash": "sha256-fbcf8691475fa17fb9ea94e6792e861271eef40d23b5b2bef2eb424db2056cba"
    },
    {
      "id": "audit-mars-first",
      "scenarioId": "mars-first",
      "name": "Mars-first Conventional Expansion",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "auditState": "decision-support-only",
      "commercialUseAllowed": false,
      "rank": 5,
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.72,
      "deterministicUtility": 40.78,
      "explanation": {
        "summary": "Strong exploration ecosystem, weak for first industrial-capacity maximization.",
        "topBenefitDrivers": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 65,
            "weight": 1,
            "weightedValue": 65
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 65,
            "weight": 1,
            "weightedValue": 65
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 46,
            "weight": 1,
            "weightedValue": 46
          }
        ],
        "topRiskDrivers": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 62,
            "weight": 1,
            "weightedValue": 62
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 64,
            "weight": 0.8,
            "weightedValue": 51.2
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 56,
            "weight": 0.9,
            "weightedValue": 50.4
          }
        ],
        "uncertainty": {
          "iterations": 128,
          "utilityP10": 38.16,
          "utilityMedian": 40.96,
          "utilityP90": 43.65,
          "downsideSpread": 2.8,
          "seed": "mars-first-decision-ledger"
        },
        "economics": {
          "businessReadinessMedian": 63.22,
          "underfundedProbabilityPercent": 1.95,
          "medianCapitalGapBn": 0,
          "economicsPromotionAllowed": false
        },
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "flipCondition": {
        "kind": "challenger-crossover-threshold",
        "comparisonScenarioId": "moon-first",
        "comparisonScenarioName": "Moon-first Bootstrap",
        "utilityGap": 26.34,
        "condition": "This scenario becomes the deterministic leader only if its benefits improve or risks fall by more than the gap to the current leader.",
        "requiredDelta": 26.34
      },
      "sensitiveAssumptions": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "utilityDelta": 0.33,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "utilityDelta": -0.06,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "utilityDelta": -0.05,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        }
      ],
      "validationProtocolRefs": [
        {
          "protocolId": "protocol-comms-autonomy",
          "domain": "comms-autonomy",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-aec24f46a6b01243742cd86a6cc49be5b6d626317a0031ecf114d1dd4d8aa5a2",
          "blockerCount": 3
        },
        {
          "protocolId": "protocol-evidence-provenance",
          "domain": "evidence-and-provenance",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-793627be3059f343ee2f7aa291d7fd819c4387d24788774051f5d6182e65acdb",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-research-package-release",
          "domain": "business-research-workflow",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-329dbe9a04571b57a50023b9046a8754ab339e37348e1877da9e08d025143864",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-space-environment",
          "domain": "space-environment",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-70feac14a3aa87120978c9c6e0f4c4a6aca51bc43cb31ce7586f9e6362bb07f1",
          "blockerCount": 4
        },
        {
          "protocolId": "protocol-trajectory-logistics",
          "domain": "trajectory-logistics",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-eb25f5788db6b754dccd4f4bed46d978b0ecb33912b50897f221139c3a39c741",
          "blockerCount": 7
        }
      ],
      "proofBurden": {
        "blockerCount": 22,
        "criticalNextProofs": [
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for mars-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "tudat-transfer-v1 runtime evidence missing for mars-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "Asteroid/resource candidates are not promoted for resource claims.",
          "Claim claim-helium3: blocked-for-commercial-proof",
          "Claim claim-mercury-core: blocked-for-commercial-proof"
        ],
        "sourcePromotionState": "source-promotion-ready-for-review",
        "sidecarPromotionState": "partial-runtime-promotion-contract-gaps",
        "modelValidationCommercialUseAllowed": false
      },
      "customerDiligenceQuestions": [
        "What evidence would reduce the Mars-first Conventional Expansion utility gap or preserve its current rank?",
        "Which assumptions are doing the most work in the ranking?",
        "Which source payloads and runtime sidecars must promote before this can become commercial proof?",
        "Would the conclusion change if launch cost, feedstock confidence, thermal burden, or comms/autonomy assumptions move conservatively?"
      ],
      "evidenceHashes": {
        "decisionHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb",
        "traceHash": "sha256-fd5108fc370a65f836309389af914613680a45a2f8d2cd12b9f04f65a9a39068",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
      },
      "evidenceBoundary": "Decision audits explain why rankings move and what proof is missing. They are not mission-design validation, investment advice, or verified resource evidence.",
      "auditHash": "sha256-1517defefde8440581d2d30e49575acd619fef37d38804fb39d6709f40bed4b2"
    },
    {
      "id": "audit-mercury-polar",
      "scenarioId": "mercury-polar",
      "name": "Mercury Polar Surface-first",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "auditState": "decision-support-only",
      "commercialUseAllowed": false,
      "rank": 6,
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.42,
      "deterministicUtility": 37.95,
      "explanation": {
        "summary": "Polar volatile access is attractive, but surface thermal/comms risk is severe.",
        "topBenefitDrivers": [
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 88,
            "weight": 1,
            "weightedValue": 88
          },
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 80,
            "weight": 1,
            "weightedValue": 80
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 74,
            "weight": 1,
            "weightedValue": 74
          }
        ],
        "topRiskDrivers": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 90,
            "weight": 1,
            "weightedValue": 90
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 88,
            "weight": 0.9,
            "weightedValue": 79.2
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 82,
            "weight": 0.8,
            "weightedValue": 65.6
          }
        ],
        "uncertainty": {
          "iterations": 128,
          "utilityP10": 33.71,
          "utilityMedian": 37.84,
          "utilityP90": 41.82,
          "downsideSpread": 4.13,
          "seed": "mercury-polar-decision-ledger"
        },
        "economics": {
          "businessReadinessMedian": 53.68,
          "underfundedProbabilityPercent": 11.91,
          "medianCapitalGapBn": 0,
          "economicsPromotionAllowed": false
        },
        "tracePromotionState": "blocked-for-commercial-proof"
      },
      "flipCondition": {
        "kind": "challenger-crossover-threshold",
        "comparisonScenarioId": "moon-first",
        "comparisonScenarioName": "Moon-first Bootstrap",
        "utilityGap": 29.17,
        "condition": "This scenario becomes the deterministic leader only if its benefits improve or risks fall by more than the gap to the current leader.",
        "requiredDelta": 29.17
      },
      "sensitiveAssumptions": [
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "utilityDelta": -0.63,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "utilityDelta": -0.45,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "utilityDelta": 0.17,
          "rankDelta": 0,
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "utilityDelta": -0.04,
          "rankDelta": 0,
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
        }
      ],
      "validationProtocolRefs": [
        {
          "protocolId": "protocol-comms-autonomy",
          "domain": "comms-autonomy",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-aec24f46a6b01243742cd86a6cc49be5b6d626317a0031ecf114d1dd4d8aa5a2",
          "blockerCount": 3
        },
        {
          "protocolId": "protocol-ephemeris-event-windows",
          "domain": "ephemeris-event-windows",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-4aef6e4c4fd115f5dd086dfa3c2a9895f3cc5853cdce2e9b7380c410f5a986d7",
          "blockerCount": 1
        },
        {
          "protocolId": "protocol-evidence-provenance",
          "domain": "evidence-and-provenance",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-793627be3059f343ee2f7aa291d7fd819c4387d24788774051f5d6182e65acdb",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-materials-process",
          "domain": "materials-process",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-95c50ec7fea3f2e2d7d68a00e3f8f7fd7c325f752f4ce78961e69432ee5118db",
          "blockerCount": 9
        },
        {
          "protocolId": "protocol-research-package-release",
          "domain": "business-research-workflow",
          "validationState": "beta-reviewable-non-commercial",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-329dbe9a04571b57a50023b9046a8754ab339e37348e1877da9e08d025143864",
          "blockerCount": 0
        },
        {
          "protocolId": "protocol-trajectory-logistics",
          "domain": "trajectory-logistics",
          "validationState": "blocked-validation-gaps",
          "commercialUseAllowed": false,
          "protocolHash": "sha256-eb25f5788db6b754dccd4f4bed46d978b0ecb33912b50897f221139c3a39c741",
          "blockerCount": 7
        }
      ],
      "proofBurden": {
        "blockerCount": 24,
        "criticalNextProofs": [
          "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for mercury-polar: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for mercury-polar: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "tudat-transfer-v1 runtime evidence missing for mercury-polar: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts.",
          "Asteroid/resource candidates are not promoted for resource claims."
        ],
        "sourcePromotionState": "source-promotion-ready-for-review",
        "sidecarPromotionState": "partial-runtime-promotion-contract-gaps",
        "modelValidationCommercialUseAllowed": false
      },
      "customerDiligenceQuestions": [
        "What evidence would reduce the Mercury Polar Surface-first utility gap or preserve its current rank?",
        "Which assumptions are doing the most work in the ranking?",
        "Which source payloads and runtime sidecars must promote before this can become commercial proof?",
        "Would the conclusion change if launch cost, feedstock confidence, thermal burden, or comms/autonomy assumptions move conservatively?"
      ],
      "evidenceHashes": {
        "decisionHash": "sha256-8bcef4c6d0b17543fd330abfe053478152e09a623045d677ca24c9f669159934",
        "traceHash": "sha256-5ab13dfa8e8a9fd561a2ee8af012a052ebd58a668b19dda311f91f6532036ecf",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
      },
      "evidenceBoundary": "Decision audits explain why rankings move and what proof is missing. They are not mission-design validation, investment advice, or verified resource evidence.",
      "auditHash": "sha256-d5377ff76fd3f456140cca4757371eb3311a861d6871ce0c7996ce9f37dbe447"
    }
  ],
  "ledgerHash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00"
}
;
